var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Col } from "react-bootstrap";
import { Select } from "@irati/ui/src/FormItem";
import { injectIntl } from "@irati/utils/lang";
import { FormGroup } from "@irati/ui/src/Form";
import Validation from "@irati/utils/validation";
import { getMaxDay, getDaysForSelect, getMonthsForSelect, getYearsForSelect, setDate } from "@irati/utils/dob";
import FormError from "@irati/ui/src/FormItem/FormError";
import { Day, Month, Year } from "./styled";
var DOBSelect = /** @class */ (function (_super) {
    __extends(DOBSelect, _super);
    function DOBSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.updateDOB = function (label, value) {
            var _a;
            if (!value)
                return;
            _this.setState((_a = {}, _a[label] = value, _a), function () {
                var onChange = _this.props.onChange;
                var day = _this.state.day;
                var _a = _this.state, month = _a.month, year = _a.year;
                var maxDay = getMaxDay(year, month);
                if (day && maxDay < day) {
                    day = "";
                    _this.setState({ day: day });
                }
                if (year === "" && month === "" && day === "") {
                    onChange(null);
                }
                else if (year) {
                    onChange(year + "-" + month + "-" + day);
                }
                else {
                    onChange(month + "-" + day);
                }
            });
        };
        _this.validate = function () {
            var _a = _this.state, day = _a.day, month = _a.month, year = _a.year;
            if (_this.props.dayMonthYearRequired || year) {
                // if `dayMonthYearRequired` or `year` set, we need all
                return year && month && day;
            }
            else if (_this.props.dayMonthRequired || month || day) {
                // if `dayMonthRequired`, `month` or `day` are set, we need both day and month
                return month && day;
            }
            // if nothing set, we're good, optional field
            return true;
        };
        _this.validationMessage = function () {
            var _a = _this.props, dayMonthYearRequired = _a.dayMonthYearRequired, excludeYear = _a.excludeYear, formatMessage = _a.formatMessage;
            if (dayMonthYearRequired) {
                return formatMessage({ id: "account.formError.formItem.validation.validFullDate" });
            }
            else if (excludeYear) {
                return formatMessage({ id: "account.formError.formItem.validation.validDateWithoutYear" });
            }
            return formatMessage({ id: "account.formError.formItem.validation.validDate" });
        };
        _this.reset = function (value) {
            _this.setState(__assign({}, setDate(value)));
        };
        _this.state = __assign(__assign({}, setDate(props.value)), { isValid: true });
        return _this;
    }
    DOBSelect.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, dayMonthRequired = _a.dayMonthRequired, dayMonthYearRequired = _a.dayMonthYearRequired, excludeYear = _a.excludeYear, isMinimumAge18 = _a.isMinimumAge18, intl = _a.intl, formatMessage = _a.formatMessage;
        var _b = this.state, day = _b.day, year = _b.year, month = _b.month;
        var formatDate = intl.formatDate;
        var dayOptions = getDaysForSelect(year, month);
        var monthOptions = getMonthsForSelect(formatDate);
        var yearOptions = getYearsForSelect(isMinimumAge18);
        var currentMonth = month && monthOptions.find(function (monthForSelect) { return monthForSelect.value === month; });
        return (React.createElement(FormGroup, null,
            React.createElement(Col, { xs: 12 },
                React.createElement("label", { htmlFor: "day" }, label)),
            React.createElement(Day, { xs: excludeYear ? 6 : 4, paddingRight: !excludeYear },
                React.createElement(Select, { name: "day", placeholder: formatMessage({ id: "platform.fields.dateOfBirth.placeholders.day" }), value: day && dayOptions.find(function (_a) {
                        var _b = _a.value, value = _b === void 0 ? "" : _b;
                        return value === day;
                    }), options: dayOptions, isClearable: false, onChange: function (value) { return _this.updateDOB("day", value); } })),
            React.createElement(Month, { xs: excludeYear ? 6 : 4, paddingRight: !excludeYear },
                React.createElement(Select, { name: "month", placeholder: formatMessage({ id: "platform.fields.dateOfBirth.placeholders.month" }), value: currentMonth, options: monthOptions, isClearable: false, onChange: function (value) { return _this.updateDOB("month", value); } })),
            !excludeYear && (React.createElement(Year, { xs: 4 },
                React.createElement(Select, { name: "year", placeholder: formatMessage({ id: "platform.fields.dateOfBirth.placeholders.year" }), value: year && { value: year, label: year }, options: yearOptions, isClearable: false, onChange: function (value) { return _this.updateDOB("year", value); } }))),
            React.createElement(FormError, { validation: Validation.string((dayMonthRequired || dayMonthYearRequired) && "platform.defaultValidation.required").test("dob", this.validationMessage(), this.validate), value: this.props.value })));
    };
    DOBSelect.defaultProps = {
        value: null,
        onChange: function () { },
        dayMonthRequired: false,
        dayMonthYearRequired: false,
        isMinimumAge18: false,
        excludeYear: false
    };
    return DOBSelect;
}(React.PureComponent));
export default injectIntl(DOBSelect, { withRef: true });
